CheckItemView = require 'app/scripts/views/checklist/check-item-view'
CollectionView = require 'app/scripts/views/internal/collection-view'

module.exports = class CheckItemListView extends CollectionView
  viewType: CheckItemView
